import React from "react";
import createReactClass from "create-react-class";
import ModalContentBase from "../modal_content_base";
import ModalEnqueteItem from "./enquete_item";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      items: [
        { item: "", sort_order: 1, tempId: 0 },
        { item: "", sort_order: 2, tempId: 1 },
        { item: "", sort_order: 3, tempId: 2 },
      ],
      title: "",
      description: "",
      optionType: 1,
      enqueteId: 0,
      isActive: false,
    };
  },
  createEnqueteToServer() {
    $.ajax({
      url: "/api/enquete/create",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        circle_id: this.props.circleId,
        title: this.state.title,
        description: this.state.description,
        option_type: this.state.optionType,
        items: this.state.items,
      },
    })
      .done(
        function(data) {
          this.setState({
            enqueteId: data,
            isActive: true,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  postEnqueteToServer() {
    $.ajax({
      url: "/api/enquete/update",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        id: this.state.enqueteId,
        circle_id: this.props.circleId,
        enquete_id: this.state.enqueteId,
        title: this.state.title,
        description: this.state.description,
        option_type: this.state.optionType,
        items: this.state.items,
      },
    })
      .done(
        function() {
          this.setState({
            isActive: false,
          });
          window.location.reload();
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  handleTitleOnChange(e) {
    this.setState({
      title: e.target.value,
    });
  },
  handleDescriptionOnChange(e) {
    this.setState({
      description: e.target.value,
    });
  },
  changeOptionType() {
    if (this.state.optionType === 1) {
      this.setState({
        optionType: 2,
      });
    } else {
      this.setState({
        optionType: 1,
      });
    }
  },
  addItem() {
    const newItem = [
      {
        item: "",
        sort_order: this.state.items.length + 1,
        tempId: this.state.items.length,
      },
    ];
    const newItems = this.state.items.concat(newItem);
    this.setState({
      items: newItems,
    });
  },
  handleUpdateItems(e) {
    let newItems = this.state.items.map(function(item) {
      if (item.tempId === e.tempId) return e;
      return item;
    });
    this.setState({
      items: newItems,
    });
  },
  componentDidMount() {},
  render() {
    const previewContent = (
      <a
        className="btn btn-info mt10 mb10 pt10 pb10"
        onClick={this.createEnqueteToServer}
      >
        <span className="color-white">
          <i className="fas fa-clipboard" aria-hidden="true" />{" "}
          アンケートをつくる
        </span>
      </a>
    );

    var optionType = "";
    if (this.state.optionType !== 1) {
      optionType = "color-main";
    }
    const items = this.state.items.map(
      function(item) {
        return (
          <ModalEnqueteItem
            item={item.item}
            sort_order={item.sort_order}
            tempId={item.tempId}
            key={item.tempId}
            handleUpdateItems={this.handleUpdateItems}
          />
        );
      }.bind(this)
    );

    const modalContent = (
      <div>
        <div className="modal-view-header">
          <p style={{ margin: "0 0 6px", padding: "1.5em", textAlign: "left" }}>
            <strong>アンケートをつくる</strong>
          </p>
        </div>
        <div
          className="modal-view-body"
          style={{ padding: "0px 25px 50px", textAlign: "left" }}
        >
          <p>
            <input
              type="text"
              className="form-control"
              placeholder="タイトル（例：イベント日程のアンケート）"
              onChange={this.handleTitleOnChange}
            />
          </p>
          <p>
            <input
              type="text"
              className="form-control mt5"
              placeholder="説明（例：空いている日を教えてね）"
              onChange={this.handleDescriptionOnChange}
            />
          </p>
          <div className="mt20">{items}</div>
          <div className="mt10">
            <div>
              <p
                className="cursor-pointer dsp-inline ml10"
                onClick={this.addItem}
              >
                <i className="fas fa-plus" />&nbsp;項目追加
              </p>
            </div>
            <div className="mt20">
              <p
                className="cursor-pointer dsp-inline"
                onClick={this.changeOptionType}
              >
                <i
                  className={`fas fa-check-circle ${optionType} font-size-16`}
                />&nbsp;複数選択可能
              </p>
            </div>
          </div>
        </div>
        <div className="modal-view-footer" style={{ padding: "1.5em" }}>
          <div className="btn btn-info" onClick={this.postEnqueteToServer}>
            作成する
          </div>
        </div>
      </div>
    );

    return (
      <ModalContentBase
        previewContent={previewContent}
        modalContent={modalContent}
        isActive={this.state.isActive}
      />
    );
  },
});
